






























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {EnvHelper} from '@/helpers/EnvHelper'

@Component
export default class CandidateVoteSwappedStep extends Vue {
  @Prop({type: String, required: true}) transactionHash!: string

  get oneGateLink() {
    return `${EnvHelper.ONE_GATE_URL}transactionInfo/${this.transactionHash}`
  }
}
